import intl from "react-intl-universal";

import {
  ModalText,
  ModalTitle,
  WrapperButtons,
  Modal as ModalDialogStyled,
} from "./styled";
import Button from "components/button";

export interface ModalProps {
  isOpen?: boolean;
  onRequestClose: () => void;
  onConfirm: () => void;
  title: string | React.ReactNode;
  textMessage: string;
}

const ModalDialog = ({
  isOpen,
  onRequestClose,
  onConfirm,
  title,
  textMessage,
  children,
}: React.PropsWithChildren<ModalProps>) => {
  const renderTitle = () => {
    if (typeof title === "string") {
      return <ModalTitle>{title}</ModalTitle>;
    }

    return title;
  };
  return (
    <ModalDialogStyled
      open={isOpen}
      contentStyle={{ width: "600px" }}
      onRequestClose={() => {
        onRequestClose();
      }}
      title={renderTitle()}
      actions={
        <WrapperButtons>
          <Button
            buttonType="default"
            value={intl.get("geral.modalConfirm.no")}
            data-testid="btn-secondary-modal"
            onClick={() => {
              onRequestClose();
            }}
            className="btn"
            style={{ width: "150px" }}
          />
          <Button
            buttonType="primary"
            value={intl.get("geral.modalConfirm.yes")}
            data-testid="btn-primary-modal"
            onClick={onConfirm}
            className="btn margin-botao"
            style={{ width: "150px" }}
          />
        </WrapperButtons>
      }
    >
      <ModalText>{textMessage}</ModalText>
      {children}
    </ModalDialogStyled>
  );
};

export default ModalDialog;
